<template>
  <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9.4375" cy="9.31152" r="7.69043" stroke="currentColor" stroke-width="1.5" />
    <line x1="13.9034" y1="14.9697" x2="19.5303" y2="20.5966" stroke="currentColor" stroke-width="1.5" />
  </svg>
</template>
